/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_UntitledInputs */

const en_admin_ai_chat_untitled = /** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled chat`)
};

const de_admin_ai_chat_untitled = /** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbenannter Chat`)
};

const es_admin_ai_chat_untitled = /** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat sin título`)
};

const fr_admin_ai_chat_untitled = /** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat sans titre`)
};

const nl_admin_ai_chat_untitled = /** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naamloze chat`)
};

/** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */
const it_admin_ai_chat_untitled = en_admin_ai_chat_untitled;

/** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_untitled = en_admin_ai_chat_untitled;

/** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */
const pl_admin_ai_chat_untitled = en_admin_ai_chat_untitled;

/** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */
const hu_admin_ai_chat_untitled = en_admin_ai_chat_untitled;

/** @type {(inputs: Admin_Ai_Chat_UntitledInputs) => LocalizedString} */
const ro_admin_ai_chat_untitled = en_admin_ai_chat_untitled;

/**
* | output |
* | --- |
* | "Untitled chat" |
*
* @param {Admin_Ai_Chat_UntitledInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_untitled = /** @type {((inputs?: Admin_Ai_Chat_UntitledInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_UntitledInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_untitled(inputs)
	if (locale === "de") return de_admin_ai_chat_untitled(inputs)
	if (locale === "es") return es_admin_ai_chat_untitled(inputs)
	if (locale === "fr") return fr_admin_ai_chat_untitled(inputs)
	if (locale === "nl") return nl_admin_ai_chat_untitled(inputs)
	if (locale === "it") return it_admin_ai_chat_untitled(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_untitled(inputs)
	if (locale === "pl") return pl_admin_ai_chat_untitled(inputs)
	if (locale === "hu") return hu_admin_ai_chat_untitled(inputs)
	return ro_admin_ai_chat_untitled(inputs)
});
export { admin_ai_chat_untitled as "admin.ai_chat.untitled" }